<template>
  <div>
    <h3>Promociones</h3>
    <uv-data-table
      :config="config"
      :data="dataPromocion"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import uvDataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "PromocionesCRUD",
  components: {
    //modal,
    uvDataTable,
    //ProductosForm
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      dataPromocion: [],

      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addPromocion",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editPromocion",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deletePromocion",
            require: true,
          },
        ],
        fields: [
          {
            text: "Promocion",
            value: "Nombre",
          },
          {
            text: "Fecha de creación",
            value: "FechaCreacion",
            format: (row) => {
              return moment(row["FechaCreacion"]).format("DD MMM YYYY hh:mm a");
            },
          },
          {
            text: "Peso Importancia",
            value: "Peso",
          },
          {
            text: "Estatus",
            value: "Vigencia",
            format: (row) => {
              if (row["Vigencia"].E) {
                return "Activo";
              } else {
                return "Inactivo";
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addPromocion") {
        this.$router.push({ path: "/productos-inventarios/promocionesEditor" });
      }
      if (buttonId == "editPromocion") {
        this.$router.push({
          path: "/productos-inventarios/promocionesEditor/" + idSelected[0],
        });
      }
      if (buttonId == "deletePromocion") {
        this.deletePromocion(idSelected[0]);
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },

    toggleModal(open) {
      this.showModal = open;
    },

    async deletePromocion(id) {
      this.$swal({
        title: "¿Deseas eliminar esta promoción?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Promociones-deletePromocion", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Promoción elimandana",
              "La Promoción se elimino correctamente",
              "success"
            );
            this.getPromociones();
          } else {
            this.$swal(
              "Error eliminando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    async getPromociones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let snapshot = await firestore.queryBuilder("PDV_Promociones", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let data = snapshot.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let sortPromo = this.$_.orderBy(data, "Peso", "desc");
      this.dataPromocion = sortPromo;
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      prod.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });

        producto.existenciaPrecio = invData;
      });

      let sortReservations = this.$_.orderBy(prod, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() {
    this.getPromociones();
  },
  created() {
    //this.MainDepartamento = localStorage.getItem("selectedDepartment")
    //this.getCategories();
  },
};
</script>
